/* repo/card*/
import {
  drop,
  fetch as fetchApi,
  insert as insertApi,
} from "./api";
import { Data } from "../store/terminalBackground/types";
import { AxiosResponse } from "axios";

function mapToChageset(processor: Data): Data {
  return processor;
}

export async function fetch(id: string | null, params?: {}): Promise<AxiosResponse<any>> {
  return fetchApi({
    nestedResourcePath: ["terminal-background"],
    id: id,
    params: params,
  }).then((response) =>
    response.data
  );
}

export async function save(data: Data): Promise<AxiosResponse<any>> {
  return insertApi({
    nestedResourcePath: ["terminal-background"],
    id: null ,
    data: { data: mapToChageset(data) },
  }).then((response) =>
    response.data
  );
}

export async function remove(id: string): Promise<AxiosResponse<any>> {
  return drop({
    nestedResourcePath: ["terminal-background"],
    id: id ,
  }).then((response) =>
    response.data
  );
}

